import { render, staticRenderFns } from "./Film.vue?vue&type=template&id=3033053a&scoped=true&"
import script from "./Film.vue?vue&type=script&lang=js&"
export * from "./Film.vue?vue&type=script&lang=js&"
import style0 from "./Film.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Film.vue?vue&type=style&index=1&id=3033053a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3033053a",
  null
  
)

export default component.exports